<template>
  <v-card :flat="flat">
    <v-card-title>New File</v-card-title>

    <v-card-text>
      <v-form ref="form" v-model="isValid">
        <v-file-input v-model="file" label="File" filled dense prepend-icon="mdi-file" show-size :rules="globalRules.fileInput"/>
        <v-select v-model="fileTypeSelected" :items="fileTypes.filter(x => !x.AUTOGENERADO && x.CODIGO !== 6)" item-text="TIPO_FICHERO" return-object label="File type" prepend-icon="mdi-file-search" outlined dense :rules="[globalRules.required]"/>
        <v-select v-model="regionSelected" :items="regions" item-text="REGION" return-object label="Region" prepend-icon="mdi-earth" outlined dense :rules="[globalRules.required]"/>
        <v-textarea v-model="description" label="Description" prepend-icon="mdi-text" outlined dense/>
      </v-form>
    </v-card-text>

    <v-card-actions justify-center align-center>
      <v-spacer/>
      <v-progress-circular color="primary" class="mx-4" v-if="isLoading" :value="uploadProgress" :indeterminate="isProcessingGDAL" :size="35"/>
      <v-btn width="150" color="red" class="white--text" @click="clearForm">CLEAR</v-btn>
      <v-btn width="150" color="primary" :disabled="!isValid" @click="initUploadFile">UPLOAD</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'FileUpload',
  props: {
    flat: Boolean
  },
  data: () => ({
    isValid: false,

    isLoading: false,
    uploadProgress: 0,

    file: null,
    fileTypeSelected: null,
    regionSelected: null,
    description: ''
  }),
  computed: {
    ...mapGetters('auth', [
      'idUsuario'
    ]),
    ...mapGetters('file', [
      'fileTypes'
    ]),
    ...mapGetters('region', [
      'regions'
    ]),
    isProcessingGDAL () {
      return this.isLoading && (this.uploadProgress === 100)
    }
  },
  methods: {
    ...mapActions('file', [
      'uploadFile'
    ]),
    clearForm () {
      this.$refs.form.reset()
    },
    async initUploadFile () {
      this.isLoading = true
      this.uploadProgress = 0

      let splitNombre = this.file.name.split('.')
      let format = splitNombre.length > 1 ? splitNombre[splitNombre.length - 1] : ''
      let fileSize = Math.round((this.file.size / 1024) * 100) / 100

      let fileItem = {
        ID_FICHERO: uuidv4(),
        ID_TIPO_FICHERO: this.fileTypeSelected.ID_TIPO_FICHERO,
        TIPO_FICHERO: this.fileTypeSelected,
        ID_REGION: this.regionSelected.ID_REGION,
        REGION: this.regionSelected,
        ID_USUARIO: this.idUsuario,
        NOMBRE: this.file.name,
        FORMATO: format,
        DESCRIPCION: this.description,
        FECHA: this.$date.getCurrentDateDB(),
        SIZE_KB: fileSize
      }

      try {
        await this.uploadFile({
          file: this.file,
          fileItem: fileItem,
          progressCallback: this.updateProgress
        })

        this.clearForm()

        this.$toastr.s('File uploaded correctly')
      } catch (err) {
        this.$toastr.e('Error uploading file')
      }

      setTimeout(() => {
        this.isLoading = false
      }, 700)
    },
    updateProgress (progress) {
      this.uploadProgress = progress
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
</style>
